import {
  ADD_RUNBOOK_SCRIPT,
  ADD_RUNBOOK_SCRIPT_FAIL,
  ADD_RUNBOOK_SCRIPT_SUCCESS,
  CREATE_DAEMON,
  CREATE_DAEMON_FAIL,
  CREATE_DAEMON_SUCCESS,
  DEPLOY_LAMBDA,
  DEPLOY_LAMBDA_FAIL,
  DEPLOYED_LAMBDA_DETAILS,
  DEPLOYED_LAMBDA_DETAILS_FAIL,
  DEPLOYED_LAMBDA_DETAILS_SUCCESS,
  DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL,
  DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS,
  EDIT_RUNBOOK_SCRIPT,
  EDIT_RUNBOOK_SCRIPT_FAIL,
  EDIT_RUNBOOK_SCRIPT_SUCCESS,
  GET_ACCOUNT_LAMBDAS_SUCCESS,
  GET_ALERTS_BASED_ON_RESOURCE,
  GET_ALERTS_BASED_ON_RESOURCE_FAIL,
  GET_ALERTS_BASED_ON_RESOURCE_SUCCESS,
  GET_ALL_DAEMONS,
  GET_ALL_DAEMONS_FAIL,
  GET_ALL_DAEMONS_SUCCESS, GET_ALL_TOKENS, GET_ALL_TOKENS_SUCCESS,
  GET_AVAILABLE_ROLES_FAIL,
  GET_AVAILABLE_ROLES_SUCCESS,
  GET_DAEMON_DETAIL_FAIL,
  GET_DAEMON_DETAIL_SUCCESS,
  GET_EXECUTE_RESULTS,
  GET_EXECUTE_RESULTS_FAIL,
  GET_EXECUTE_RESULTS_SUCCESS,
  GET_LAMBDAS_FAIL,
  GET_LAMBDAS_SUCCESS,
  GET_MAPPED_LAMBDA_ALERTS_FAIL,
  GET_MAPPED_LAMBDA_ALERTS_SUCCESS,
  GET_RUNBOOK_SCRIPTS,
  GET_RUNBOOK_SCRIPTS_FAIL,
  GET_RUNBOOK_SCRIPTS_SUCCESS,
  MAP_ALERT_TO_LAMBDA,
  MAP_ALERT_TO_LAMBDA_FAIL,
  MAP_ALERT_TO_LAMBDA_SUCCESS,
  REFRESH_DAEMON_ACCESS_TOKEN_FAIL,
  REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS,
} from "./actionTypes"


const INIT_STATE = {
  execute_results: {
    loading: false,
    execute_requests: []
  },
  daemon_token_details: {
    token: "",
    daemon_exists: null,
    loading: false
  },
  daemon_details: {
    loading: false,
    total_count: null,
    daemons: []
  },
  daemon_detail: {},
  deployed_lambdas: {},
  master_lambdas: [],
  runbook_scripts: [],
  loading: {
    addScript: false
  },
  error: null,
  resource_alerts: {
    loading: false
  },
  mapped_alerts: [],
  deployed_account_lambdas:[],
  available_roles: [],
  available_tokens:[]
};

const Daemon = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_DAEMON:
      return {
        ...state,
        error: null,
        daemon_token_details: {
          ...state.daemon_token_details,
          loading: true
        },
      }
    case CREATE_DAEMON_SUCCESS:
      return {
        ...state,
        daemon_token_details: {...action.payload, loading: false},
      }
    case CREATE_DAEMON_FAIL:
      return {
        ...state,
        error: action.payload,
        daemon_token_details: {...state.daemon_token_details, loading: false},
      }

    case REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        daemon_token_details: {...action.payload , loading: false},
      }
    case REFRESH_DAEMON_ACCESS_TOKEN_FAIL:
      return {
        ...state,
        error: action.payload,
        daemon_token_details: {...state.daemon_token_details, loading: false},
      }
    case GET_ALL_DAEMONS:
      return {
        ...state,
        daemon_details: {
          ...state.daemon_details,
          loading: true
        }
      }
    case GET_ALL_DAEMONS_SUCCESS:
      return {
        ...state,
        daemon_token_details: INIT_STATE.daemon_token_details,
        daemon_details: {
          loading: false,
          ...action.payload
        },
      }
    case GET_ALL_DAEMONS_FAIL:
      return {
        ...state,
        daemon_token_details: INIT_STATE.daemon_token_details,
        error: action.payload,
      }
    case GET_EXECUTE_RESULTS:
      return {
        ...state,
        execute_results : {
          ...state.execute_results,
          loading: true
        },
      }
    case GET_EXECUTE_RESULTS_SUCCESS:
      return {
        ...state,
        execute_results : action.payload,
      }
    case GET_EXECUTE_RESULTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_LAMBDAS_SUCCESS:
      return {
        ...state,
        master_lambdas: action.payload.master_lambdas,
        deployed_lambdas: action.payload.deployed_lambdas,
      }

    case GET_LAMBDAS_FAIL:
      return {
        ...state,
        error: action.payload,

      }
    case DEPLOY_LAMBDA:
      return {
        ...state,
        error: null,
      }
    case DEPLOY_LAMBDA_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DEPLOYED_LAMBDA_DETAILS:
      return {
        ...state,
        error: null
      }
    case DEPLOYED_LAMBDA_DETAILS_SUCCESS:
      return {
        ...state,
        deployed_lambdas: [...state.deployed_lambdas, {
          "id": action.payload.id,
          "lambda_arn": action.payload.lambda_arn,
          "role_arn": action.payload.role_arn,
          "script_url": action.payload.script_url,
          "name": action.payload.name
        }],
        master_lambdas: state.master_lambdas.filter((master_lambda) => master_lambda.id !== action.payload.master_lambda_id)
      }
    case DEPLOYED_LAMBDA_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_RUNBOOK_SCRIPT:
      return {
        ...state,
        loading: {
          ...state.loading,
          addScript: true
        },
        error: null
      };
    case ADD_RUNBOOK_SCRIPT_SUCCESS:
      return {
        ...state,
        runbook_scripts: [...(state.runbook_scripts || []), action.payload],
        loading: {
          ...state.loading,
          addScript: false
        },
        error: null
      };
    case ADD_RUNBOOK_SCRIPT_FAIL:
      return {
        ...state,
        loading: {
          ...state.loading,
          addScript: false
        },
        error: action.payload
      };
    case GET_RUNBOOK_SCRIPTS:
      return {
        ...state,
        loading: { ...state.loading, getScripts: true },
        error: null
      };

    case GET_RUNBOOK_SCRIPTS_SUCCESS:
      return {
        ...state,
        runbook_scripts: action.payload,
        loading: { ...state.loading, getScripts: false },
        error: null
      };

    case GET_RUNBOOK_SCRIPTS_FAIL:
      return {
        ...state,
        loading: { ...state.loading, getScripts: false },
        error: action.payload
      };
    case EDIT_RUNBOOK_SCRIPT:
      return {
        ...state,
        loading: {
          ...state.loading,
          editScript: true
        },
        error: null
      };

    case EDIT_RUNBOOK_SCRIPT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          editScript: false
        },
        error: null
      };

    case EDIT_RUNBOOK_SCRIPT_FAIL:
      return {
        ...state,
        loading: {
          ...state.loading,
          editScript: false
        },
        error: action.payload
      };

    case GET_ALERTS_BASED_ON_RESOURCE:
      return {
        ...state,
        resource_alerts: {
          loading: true
        }
      }
    case GET_ALERTS_BASED_ON_RESOURCE_SUCCESS:
      return {
        ...state,
        resource_alerts: {
          ...action.payload,
          loading: false
        },
        error: null
      }
    case GET_ALERTS_BASED_ON_RESOURCE_FAIL:
      return {
        ...state,
        resource_alerts: {
          loading: false
        },
        error: action.payload
      }
    case MAP_ALERT_TO_LAMBDA_SUCCESS:
      return {
        ...state,
        mapped_alerts: [...state.mapped_alerts, ...action.payload],
        error: null
      }
    case MAP_ALERT_TO_LAMBDA_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS:
      return {
        ...state,
        mapped_alerts: state.mapped_alerts.filter((alert) => alert.alert_id !== action.payload.alert_id),
        error: null
      }
    case DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case GET_MAPPED_LAMBDA_ALERTS_SUCCESS:
      return {
        ...state,
        mapped_alerts: action.payload
      }
    case GET_MAPPED_LAMBDA_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case GET_DAEMON_DETAIL_SUCCESS:
      return {
        ...state,
        daemon_detail: action.payload
      }
    case GET_DAEMON_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case GET_ACCOUNT_LAMBDAS_SUCCESS:
      return {
        ...state,
        deployed_account_lambdas: action.payload.deployed_lambdas,
      }
    case GET_AVAILABLE_ROLES_SUCCESS:
      return {
        ...state,
        available_roles: action.payload,
      }
    case GET_AVAILABLE_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case GET_ALL_TOKENS_SUCCESS:
      return {
        ...state,
        available_tokens: action.payload,
      }
    default:
      return state;
  }
}

export default Daemon;
